<template>
  <div style="padding-bottom: 100px" class="centered">
    <el-tabs tab-position="left" style="margin-left: -25px">
      <el-tab-pane label="Por C. Custo" style="">
        <div class="center_" style="background: #fff" v-if="finshedLoad">
          <div>
            <div class="header-title">
              <p class="title_" style="">
                <b-icon
                  style="margin-right: 10px"
                  class="icon-beaut"
                  icon="chevron-left"
                  font-scale="1"
                  @click="() => this.$router.push('/apportionmentBylocation')"
                ></b-icon>
                Rateio {{ dayjs(apportionment.month).format("MM/YYYY") }}
              </p>
              <el-input
                style="width: 300px; margin-top: -5px"
                v-model="searchProjects"
                size="medium"
                placeholder="Fazer busca"
                clearable
                :value="searchProjects"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
          </div>
          <HeaderApportionment :apportionment="apportionment" />
          <div
            style="margin-top: 50px; margin-left: -25px"
            class="table-teste"
            v-if="finshedLoad && dataTableProjects.length > 0"
          >
            <ProjectsTable
              :dataTable="dataTableProjects"
              :getInformations="getInformations"
              :apportionment="apportionment"
              :search="searchProjects"
              @toggle-drawer="handleInsertInformations"
              @toggle-apportionment="handleApportionment"
            />
          </div>
          <div style="font-size: 14px; padding: 25px" v-else>
            <el-skeleton
              :rows="8"
              animated
              v-if="!finshedLoad"
              style="width: 100%"
            />
            <div style="margin-left: -25px; margin-top: 30px">
              <span class="">
                {{
                  dataTableProjects.length === 0 && finshedLoad
                    ? "Sem dados de rateios para exibir."
                    : ""
                }}
              </span>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="Por Colaborador" stretch>
        <div class="center_" v-if="finshedLoad">
          <div>
            <div class="header-title">
              <p class="title_" style="">
                <b-icon
                  style="margin-right: 10px"
                  class="icon-beaut"
                  icon="chevron-left"
                  font-scale="1"
                  @click="() => this.$router.push('/apportionmentBylocation')"
                ></b-icon>
                Rateio {{ dayjs(apportionment.month).format("MM/YYYY") }}
              </p>
              <el-input
                style="width: 300px; margin-top: -5px"
                v-model="searchCollab"
                size="medium"
                placeholder="Fazer busca"
                clearable
                :value="searchCollab"
              >
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
            </div>
          </div>
          <HeaderApportionment :apportionment="apportionment" />
          <div
            style="margin-top: 50px; margin-left: -25px"
            class="table-teste"
            v-if="finshedLoad && dataTableCollaborators.length > 0"
          >
            <CollaboratorsTable
              :search="searchCollab"
              :dataTable="dataTableCollaborators"
              :apportionment="apportionment"
              :getInformations="getInformations"
              @toggle-drawer="handleInsertInformations"
              @toggle-apportionment="handleApportionment"
            />
          </div>
          <div style="font-size: 14px; padding: 25px" v-else>
            <el-skeleton
              :rows="8"
              animated
              v-if="!finshedLoad"
              style="width: 100%"
            />
            <div style="margin-left: -25px; margin-top: 30px">
              <span class="">
                {{
                  dataTableCollaborators.length === 0 && finshedLoad
                    ? "Sem dados de rateios para exibir."
                    : ""
                }}
              </span>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-drawer
      title="Inserir distribuição"
      :visible.sync="drawerNewDistribution"
      :before-close="handleCloseNewDistribution"
      :wrapperClosable="false"
    >
      <div class="drawer">
        <div class="drawer-text-header">
          <span class="drawer-text-title">Alocação</span>
        </div>
        <div class="drawer-content">
          <div style="display: flex; flex-direction: column">
            <div v-if="typeInsert === 'collaborator'">
              <span class="drawer-text-title" style="font-size: 12px !important"
                >Escolha o colaborador</span
              >
              <div
                class="drawer-inner-content"
                style="margin-bottom: 35px; margin-top: 15px"
              >
                <input
                  type="text"
                  autocomplete="off"
                  list="browsers-collab"
                  class="text-input"
                  v-model="currentCollaborator"
                />
                <div class="dropdown-container">
                  <datalist id="browsers-collab">
                    <option
                      v-for="(item, index) in getCollaborators"
                      :key="`collab-${index}`"
                    >
                      {{ item.name }}
                    </option>
                  </datalist>
                </div>
              </div>
            </div>
            <div v-else>
              <span
                class="drawer-text-title"
                style="font-size: 12px !important; margin-bottom: 15px"
                >Escolha o centro de custo</span
              >
              <div
                class="drawer-inner-content"
                style="margin-bottom: 35px; margin-top: 15px"
              >
                <input
                  type="text"
                  autocomplete="off"
                  list="browsers-collab"
                  class="text-input"
                  v-model="currentCostCenter"
                />
                <div class="dropdown-container">
                  <datalist id="browsers-collab">
                    <option
                      v-for="(item, index) in getCostCenters"
                      :key="`collab-${index}`"
                    >
                      {{ item.name }}
                    </option>
                  </datalist>
                </div>
              </div>
            </div>
            <span
              class="drawer-text-title"
              style="font-size: 12px !important; margin-bottom: 15px"
              >Informe o valor para alocação</span
            >
            <div class="drawer-inner-content">
              <money
                id="inputDrawer"
                v-model="currentValue"
                v-bind="money"
                style="width: 130px; margin-right: 10px"
                class="el-input__inner text-input"
              />
            </div>
          </div>
          <div class="drawer-footer">
            <el-button
              style="background: #eaeaea; color: #515151"
              type="text"
              @click="handleDrawerNewDistributionCancel"
              >cancelar</el-button
            >
            <el-button
              @click="insertDistribution"
              :loading="isLoadingBtnConfirm"
              >Inserir</el-button
            >
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<style>
.el-table__expand-icon {
  visibility: visible;
}

.header {
  margin-top: -100px;
  position: fixed;
  z-index: 1;
  width: 82%;
  background-color: #fff;
  margin-left: -10px;
  padding-top: 50px;
  padding-bottom: 15px;
  border-bottom: 1px solid #dadada;
}

.table-teste {
  overflow: auto;
}

.el-tabs--left .el-tabs__header.is-left {
  position: fixed;
  z-index: 2;
}

.el-tabs__active-bar {
  background-color: #e87305 !important;
}

.el-tabs--left .el-tabs__item.is-left:hover {
  color: #e87305 !important;
}

.el-tabs__item.is-active {
  color: #e87305 !important;
}

.center_ {
  margin-left: 175px;
  margin-top: 10px;
}

.sidebar {
  margin-top: 8px;
  border: 0px !important;
  border-left: 2px solid #fff !important;
  color: #000 !important;
  padding-left: 12px !important;
}

.sidebar:hover {
  background-color: #f5f5f5;
  color: #000 !important;
}

.sidebar:focus {
  color: #e87305 !important;
  border-left: 2px solid #e87305 !important;
}

.sidebar:active {
  color: #e87305 !important;
  border-left: 2px solid #e87305 !important;
}

.sidebar.active {
  color: #e87305 !important;
  border-left: 2px solid #e87305 !important;
}

.sidebar:checked {
  color: #e87305 !important;
  border-left: 2px solid #e87305 !important;
}

.cursor-pointer {
  cursor: pointer !important;
}

.table-container {
  width: 1300px;
  padding-bottom: 20px;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import store from "../utils/store";
import api from "../utils/api";
import dayjs from "../utils/dayjs";

import constants from "../utils/constants";
import Paginator from "../components/Paginator.vue";
import ProjectsTable from "../components/CostCentersTable.vue";
import CollaboratorsTable from "../components/CollaboratorsTable.vue";
import HeaderApportionment from "../components/HeaderApportionment.vue";

import { Money } from "v-money";

export default {
  name: "Apportionment",
  components: {
    Paginator,
    ProjectsTable,
    CollaboratorsTable,
    HeaderApportionment,
    Money,
  },
  data() {
    return {
      isLoadingBtnConfirm: false,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
      collaboratorId: "",
      typeInsert: "",
      currentCollaborator: "",
      currentValue: 0,
      currentCostCenterId: "",
      drawerNewDistribution: false,
      searchProjects: "",
      searchCollab: "",
      constants: constants,
      currentCostCenter: "",
      locationId: null,
      dayjs: dayjs,
      finshedLoad: false,
      dataTableProjects: [],
      dataTableCollaborators: [],
      apportionment: null,
      drawer: false,
      currentPercentage: 0,
      pageCollab: 1,
    };
  },
  computed: {
    ...mapGetters(["getLocationId", "formatterNumber"]),
    getCollaborators() {
      return this.dataTableCollaborators;
    },
    getCostCenters() {
      return this.dataTableProjects;
    },
  },
  async created() {
    this.updateNavCurrentIndex("1");
    this.finshedLoad = false;
    const id = this.$route.params.id;
    const array_teste = store.state.navItems.map((e) => {
      if (
        e.route === "/" ||
        e.route === "/upload" ||
        e.route === "/apportionmentBylocation"
      ) {
        return { ...e, disabled: false, route: `/apportionment/${id}` };
      } else {
        return { ...e, disabled: false };
      }
    });
    this.locationId = this.getLocationId;
    this.updateNavItems_(array_teste);
    await this.getInformations();
    this.finshedLoad = true;
  },
  watch: {
    getLocationId: function (val) {
      this.locationId = val;
    },
  },
  methods: {
    ...mapActions(["updateNavItems", "updateNavCurrentIndex"]),
    handleApportionment(apportionment) {
      this.apportionment.total_planned = apportionment.planned_value;
      this.apportionment.total_available = apportionment.indirect_value;
      this.apportionment.total_used = apportionment.used_value;
      this.apportionment.percent_used =
        (apportionment.used_value / apportionment.planned_value) * 100;
    },
    handleDrawerNewDistributionCancel() {
      this.currentCostCenter = "";
      this.currentCostCenterId = "";
      this.currentPercentage = 0;
      document.getElementById("inputDrawer").value = "";
      this.drawerNewDistribution = false;
      this.isLoadingBtnConfirm = false;
    },
    updateNavItems_(array_teste) {
      this.updateNavItems(array_teste);
    },
    handleInsertInformations({
      cost_center_destiny_id,
      typeInsert,
      collaborator_id,
    }) {
      this.collaboratorId = collaborator_id;
      this.currentCostCenterId = cost_center_destiny_id;
      this.typeInsert = typeInsert;
      this.drawerNewDistribution = true;
    },
    handleCloseNewDistribution() {
      this.currentValue = 0;
      this.currentCostCenter = "";
      this.currentCostCenterId = "";
      this.currentPercentage = 0;
      this.drawerNewDistribution = false;
      this.isLoadingBtnConfirm = false;
    },
    insertDistribution() {
      this.isLoadingBtnConfirm = true;

      this.$confirm(
        "Após esta ação a distribuição será inserida",
        `Salvar informações`,
        {
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          customClass: "alert-class",
          confirmButtonClass: "btnFalses",
          cancelButtonClass: "btnCancelFalses",
          type: "warning",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "Inserindo...";
              let obj = null;
              if (this.typeInsert === "collaborator") {
                obj = {
                  apportionment_id: this.apportionment.id,
                  cost_center_destiny_id: this.currentCostCenterId,
                  collaborator_id: this.getCollaborators.find(
                    (e) => e.name === this.currentCollaborator
                  ).id,
                  value_allocated: this.currentValue,
                };
              } else {
                obj = {
                  apportionment_id: this.apportionment.id,
                  cost_center_destiny_id: this.getCostCenters.find(
                    (e) => e.name === this.currentCostCenter
                  ).id,
                  collaborator_id: this.collaboratorId,
                  value_allocated: this.currentValue,
                };
              }
              api
                .post(`/insertDistribution`, obj)
                .then(async ({ data }) => {
                  let index = 0;
                  if (this.typeInsert === "collaborator") {
                    for (let elem of this.dataTableProjects) {
                      if (elem.id === this.currentCostCenterId) {
                        this.insertElement(index, data, "distribution");
                        break;
                      }
                      index++;
                    }
                  } else {
                    for (let elem of this.dataTableCollaborators) {
                      if (elem.id === this.collaboratorId) {
                        this.insertElement(index, data, "distribution");
                        break;
                      }
                      index++;
                    }
                  }

                  this.isLoadingBtnConfirm = false;
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Confirmar";
                  this.drawerNewDistribution = false;
                  this.currentCollaborator = "";
                  document.getElementById("inputDrawer").value = "";
                  this.currentCostCenterId = "";
                  this.currentCostCenter = "";
                  this.handleApportionment(data.apportionment);
                  done();
                  this.$message({
                    type: "success",
                    message: "Inserido com sucesso!",
                  });
                })
                .catch(() => {
                  this.isLoadingBtnConfirm = false;
                  instance.confirmButtonLoading = false;
                  instance.confirmButtonText = "Confirmar";
                  this.$message({
                    type: "error",
                    message: "Erro ao tentar salvar informações.",
                  });
                });
            } else {
              this.isLoadingBtnConfirm = false;
              instance.confirmButtonLoading = false;
              this.isLoadingBtnConfirm = false;
              instance.confirmButtonText = "Confirmar";
              done();
            }
          },
        }
      )
        .then(() => {})
        .catch(() => {
          this.isLoadingBtnClose = false;
        });
    },
    insertElement(index, newValue, key) {
      if (this.typeInsert === "collaborator") {
        this.dataTableProjects[index].indirect_percentage_used =
          (newValue.distribution.costCenter.used_value /
            newValue.distribution.costCenter.planned_value) *
          100;
        this.dataTableProjects[index].indirect_value_used =
          newValue.distribution.costCenter.used_value;
        this.dataTableProjects[index].indirect_difference =
          this.handleToLocaleString(
            this.formatterNumber(
              newValue.distribution.costCenter.planned_value -
                newValue.distribution.costCenter.used_value
            )
          );
        this.dataTableProjects[index][key].push({
          ...newValue.distribution.costCenter,
          id: newValue.distribution.id,
        });
      } else {
        this.dataTableCollaborators[index].residual =
          newValue.distribution.collaborator.residual;
        this.dataTableCollaborators[index][key].push({
          id: newValue.distribution.id,
          percentage_allocated:
            newValue.distribution.collaborator.percentage_allocated,
          value_allocated: newValue.distribution.collaborator.value_allocated,
          cost_center_name: this.currentCostCenter,
        });
      }
    },
    handleToLocaleString(value) {
      return value.toLocaleString(this.constants.language, {
        style: "currency",
        currency: this.constants.currency,
      });
    },
    async handleCollaboratorsTable() {
      const collaborators = await api.get(
        `/findOneApportionments/${this.currentApportionmentId}?by=collaborators`
      );
      this.dataTableCollaborators = collaborators.data.collaborators.map(
        (elem) => {
          return {
            ...elem,
            referential: elem.total_cost,
            total_cost: this.handleToLocaleString(elem.total_cost),
          };
        }
      );
    },
    async getInformations() {
      this.currentApportionmentId = this.$route.params.id;
      const projects = await api.get(
        `/findOneApportionments/${this.currentApportionmentId}?by=costCenters`
      );
      this.dataTableProjects = projects.data.cost_centers.map((elem) => {
        return {
          ...elem,
          direct_value: this.handleToLocaleString(elem.direct_value),
          indirect_value_used: this.handleToLocaleString(
            elem.indirect_value_used
          ),
          referential: elem.indirect_value_planned,
          indirect_value_planned: this.handleToLocaleString(
            elem.indirect_value_planned
          ),
          indirect_value: this.handleToLocaleString(elem.indirect_value),
          indirect_difference: this.handleToLocaleString(
            this.formatterNumber(elem.indirect_difference)
          ),
        };
      });
      this.apportionment = projects.data;
      this.apportionment.percent_used =
        (projects.data.total_used / projects.data.total_planned) * 100;

      this.handleCollaboratorsTable();
    },
  },
};
</script>
